import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["file", "preview", "signedId"]
  static values = {
    url: String
  }

  connect() {
    console.log("avatar-uploader connected")
  }

  fileTargetConnected() {
    this.fileTarget.addEventListener("change", this.preview.bind(this))
  }

  fileTargetDisconnected() {
    this.fileTarget.removeEventListener("change", this.preview.bind(this))
  }

  trigger() {
    // console.log("avatar-uploader trigger")
    this.fileTarget.click()
  }

  clear() {
    // console.log("avatar-uploader clear")
    this.fileTarget.value = ""
    this.previewTarget.src = this.urlValue
    this.signedIdTarget.value = ""
  }

  preview(event) {
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.previewTarget.src = e.target.result
      }
      reader.readAsDataURL(file)
    } else {
      this.clear()
    }
  }
}
